import React from 'react'
import { Layer, Group, Image } from 'react-konva'
import { formatRBGColor } from '~/Util'
import { useAssetShape } from '~/components/Preview/lib'
import { TextTransformer } from './TextTransformer'
import { TextAsset } from '~/models/Asset'

const AssetShape = React.memo(({
  asset,
  index,
  source,
  size,
  scale,
  boundingRect,
  extSourcePos,
  extSourceSize = {},
  extSourceRotation = null,
  settings = {},
  outline = {},
  animation,
  onChange,
  isTransform,
}) => {
  const { layer, params, outlineColor, outlineWidth, width, height, opacity } = useAssetShape({
    extSourcePos,
    extSourceSize,
    extSourceRotation,
    settings,
    outline,
    animation,
    onChange,
    size,
    index,
    scale,
    boundingRect,
    asset,
  })
  const isTextTransform = isTransform && (asset instanceof TextAsset)

  return (
    <Layer
      id={asset.id}
      clip={boundingRect}
      listening={false}
      ref={layer}
      willReadFrequently={isTextTransform}
    >
      <Group {...params} willReadFrequently={isTextTransform}>
        {isTransform && (asset instanceof TextAsset)
          ? (
            <TextTransformer
              source={source}
              width={width}
              height={height}
              opacity={opacity ? opacity / 100 : undefined}
              strokeWidth={outlineWidth ? outlineWidth * scale.x : 0}
              stroke={outlineColor ? formatRBGColor(outlineColor) : undefined}
              extSourceSize={extSourceSize}
              scale={scale}
            />
          )
          : (
            <Image
              image={source}
              width={width}
              height={height}
              opacity={opacity ? opacity / 100 : undefined}
              strokeWidth={outlineWidth ? outlineWidth * scale.x : 0}
              stroke={outlineColor ? formatRBGColor(outlineColor) : undefined}
              perfectDrawEnabled={false}
              listening={false}
              shadowForStrokeEnabled={false}
              hitGraphEnabled={false}
            />
          )}
      </Group>
    </Layer>
  )
})

export default AssetShape
